/*
 * @Author: cmchiu
 * @Date: 2022-04-28 11:03:41
 * @LastEditTime: 2022-05-06 09:55:38
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\store\getters.js
 *
 */
const getters = {
    keyword: (state) => state.app.keyword,
    stid: (state) => state.app.stid,
    pnTitle: (state) => state.app.pnTitle,
}

export default getters
